<template>
  <h1 v-bind="$attrs"><slot></slot></h1>
</template>
<script>
export default {
  name: "TangramTitle",
  inheritAttrs: false,
};
</script>
<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Red+Hat+Display:wght@400;600&display=swap");

:root {
  font-family: "Red Hat Display", sans-serif;
}

h1 {
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 3.125rem;
  color: #000000;
  font-style: normal;
  font-family: "Red Hat Display", sans-serif;
}
</style>
